<template>
  <NotificationPanel :notifications-visible="notificationsVisible" />
</template>

<script>
import { defineAsyncComponent } from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'NotificationPanelWrapper',

  components: {
    NotificationPanel: defineAsyncComponent(() => import('@/app/components/notifications/NotificationPanel.vue')),
  },

  computed: {
    ...mapGetters(['notificationsVisible']),
  },
}
</script>
